var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-carousel",
    { ref: "carousel_1", attrs: { interval: 9000 } },
    [
      _c("el-carousel-item", [
        _c("h3", [_vm._v("Webhook 通知")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "当有工单需要你处理，或你的工单有别人处理时，系统可以发送及时的通知，给你的钉钉或企业微信群，或者推送给你的另一个业务系统"
          )
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v("联系 "),
          _c("a", { attrs: { target: "_blank", href: "/ticket/h" } }, [
            _vm._v("管理员")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("el-carousel-item", [
        _c("h3", [_vm._v("工单模板")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "你可以使用工单模板, 存储一些你经常输入的内容, 在需要时引用; 就可以不再很多次输入重复的内容了"
          )
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "可以在新建工单, 回复工单, 指派工单时, 在内容输入框的下面, 点击 "
          ),
          _c("b", [_vm._v("[模板]")]),
          _vm._v(" 按钮引用")
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v("如果需要定制相关内容, 可向 "),
          _c("a", { attrs: { target: "_blank", href: "/ticket/h" } }, [
            _vm._v("管理员")
          ]),
          _vm._v(" 联系")
        ])
      ]),
      _vm._v(" "),
      _c("el-carousel-item", [
        _c("h3", [_vm._v("什么是视图")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v("视图的本质是一些查询条件,用以筛选出我们关心的一些工单")
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v("例如, "),
          _c("b", [_vm._v("与我有关")]),
          _vm._v(
            ", 包含了, 当前用户创建的, 或指派给当前用户, 或抄送给当前用户, 并且状态为未关闭的所有工单"
          )
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "如果你需要定制一些你独有的查询条件, 例如: 类型为招募且状态为未完成的; 或内容包含工资且创建时间在半个月以内的, 可向 "
          ),
          _c("a", { attrs: { target: "_blank", href: "/ticket/h" } }, [
            _vm._v("管理员")
          ]),
          _vm._v(" 联系")
        ])
      ]),
      _vm._v(" "),
      _c("el-carousel-item", [
        _c("h3", [_vm._v("工作流(自定义流程)")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v("联系 "),
          _c("a", { attrs: { target: "_blank", href: "/ticket/h" } }, [
            _vm._v("管理员")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("el-carousel-item", [
        _c("h3", [_vm._v("自定义表单")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v("联系 "),
          _c("a", { attrs: { target: "_blank", href: "/ticket/h" } }, [
            _vm._v("管理员")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("el-carousel-item", [
        _c("h3", [_vm._v("工单系统能做什么")]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v("不具体吹了, 参考"),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "https://www.baidu.com/s?wd=工单系统"
              }
            },
            [_vm._v("百度搜索")]
          ),
          _vm._v(", "),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "https://baike.baidu.com/item/工单系统"
              }
            },
            [_vm._v("百度百科")]
          )
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("p", [
          _vm._v("联系 "),
          _c("a", { attrs: { target: "_blank", href: "/ticket/h" } }, [
            _vm._v("管理员")
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0927b9f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0927b9f1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserGuideCarousel.vue
// module id = 581
// module chunks = 75